module.exports = __webpack_public_path__ + "media/rubber_1.97c6ce51.mp3";